import Model from './model'

class Gallery extends Model {

  constructor(gallery) {
    super()
    this.id = gallery.id
    this.name = gallery.name
    this.projects_list = gallery.projects_list
    this.updated_at = gallery.updated_at
    this.created_at = gallery.created_at
  }

  static all() {
    return this.api.get('galleries')
      .then(res => res.data)
  }

}

export default Gallery



// WEBPACK FOOTER //
// ./src/models/gallery.js